import { render, staticRenderFns } from "./ManualRedeem.vue?vue&type=template&id=4de20e30"
import script from "./ManualRedeem.vue?vue&type=script&lang=js"
export * from "./ManualRedeem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports